import type { SVGProps } from 'react';
const DawnFlagAW = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-AW_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-AW_svg__a)">
      <g filter="url(#dawn-flag-AW_svg__b)">
        <path fill="#4189DD" d="M0 0h22v16H0z" />
      </g>
      <path
        fill="#D21034"
        stroke="#fff"
        strokeWidth={0.667}
        d="m4.485 1.978-.293-.572-.293.572-.49.958-.942.5-.56.297.56.299.941.5.49.957.294.571.293-.571.49-.958.941-.5.561-.298-.561-.298-.94-.5z"
      />
      <path fill="#F9D616" d="M0 11.733h22V12.8H0zM0 9.6h22v1.067H0z" />
    </g>
    <defs>
      <filter
        id="dawn-flag-AW_svg__b"
        width={24}
        height={18}
        x={-1}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_2115" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_2115" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagAW;
